import { useEffect, useState } from "react";

const EVENT = "hd2:openClassPicker";

export function openClassPicker() {
	window.dispatchEvent(new Event(EVENT));
}

export function useClassPickerState(): [boolean, (open: boolean) => void] {
	const [open, setOpen] = useState(false);
	useEffect(() => {
		const handler = () => setOpen(true);
		window.addEventListener(EVENT, handler);
		return () => window.removeEventListener(EVENT, handler);
	}, []);
	return [open, setOpen];
}
